import React from 'react';
import { ResponsiveStyleValue, TabsColor, TabsPositioning, TabsSize, TabsValue, TabsVariant } from '../../theming';

export function getSafeId(uid: string) {
    return (value: string | number) => {
        return `${uid}-${value}`;
    };
}

export interface TabsContextValues {
    baseId?: string;
    value?: TabsValue;
    onChange?: (event: React.SyntheticEvent, value: TabsValue) => void;
    onKeyDown?: (event: React.KeyboardEvent) => void;
    positioning?: TabsPositioning;
    underline?: boolean;
    ariaLabel?: string;
    keepMounted?: boolean;
    getTabId: ((value: string | number) => string) | null;
    getPanelId: ((value: string | number) => string) | null;
    variant: TabsVariant;
    color: TabsColor;
    size: ResponsiveStyleValue<TabsSize>;
    tabListRef: React.MutableRefObject<HTMLUListElement | null> | null;
}

export const TabsContext = React.createContext<TabsContextValues>({
    getTabId: null,
    getPanelId: null,
    tabListRef: null,
    variant: 'default',
    color: 'default',
    size: 'm',
});

export function useTabs(): TabsContextValues {
    return React.useContext(TabsContext);
}
